<template>
  <el-badge is-dot :hidden="hasfilter">
    <el-button size="mini" type="info" plain @click="dialog = true">Mais filtros</el-button>
      <el-drawer
        title="Filtro de Postagem"
        :visible.sync="dialog"
        direction="rtl"
        custom-class="demo-drawer"
        ref="drawer"
        size="50%"
        :wrapperClosable="false"
        :append-to-body="true"
        :modal-append-to-body="false"
        :modal="true"
      >
      <div class="demo-drawer__content" style="padding: 10px">
        <el-form :model="filter" label-position="top" size="mini">
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="PLP">
                <el-input v-model="filter.plp" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Registros">
                <el-select v-model="filter.records">
                  <el-option-group :key="50" label="Registros por página">
                    <el-option :key="50" :label="50" :value="50"></el-option>
                    <el-option :key="100" :label="100" :value="100"></el-option>
                    <el-option :key="150" :label="150" :value="150"></el-option>
                    <el-option :key="200" :label="200" :value="200"></el-option>
                    <el-option :key="250" :label="250" :value="250"></el-option>
                    <el-option :key="300" :label="300" :value="300"></el-option>
                    <el-option :key="350" :label="350" :value="350"></el-option>
                    <el-option :key="400" :label="400" :value="400"></el-option>
                    <el-option :key="450" :label="450" :value="450"></el-option>
                    <el-option :key="500" :label="500" :value="500"></el-option>
                    <el-option
                      :key="1000"
                      :label="1000"
                      :value="1000"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="CEP">
                <el-input
                  v-model="filter.zipcode"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Estado">
                <el-select v-model="filter.state" filterable>
                  <el-option key="" label="Todos" value=""></el-option>
                  <el-option key="AC" label="Acre" value="AC"></el-option>
                  <el-option key="AL" label="Alagoas" value="AL"></el-option>
                  <el-option key="AP" label="Amapá" value="AP"></el-option>
                  <el-option key="AM" label="Amazonas" value="AM"></el-option>
                  <el-option key="BA" label="Bahia" value="BA"></el-option>
                  <el-option key="CE" label="Ceará" value="CE"></el-option>
                  <el-option
                    key="DF"
                    label="Distrito Federal"
                    value="DF"
                  ></el-option>
                  <el-option
                    key="ES"
                    label="Espírito Santo"
                    value="ES"
                  ></el-option>
                  <el-option key="GO" label="Goiás" value="GO"></el-option>
                  <el-option key="MA" label="Maranhão" value="MA"></el-option>
                  <el-option
                    key="MT"
                    label="Mato Grosso"
                    value="MT"
                  ></el-option>
                  <el-option
                    key="MS"
                    label="Mato Grosso do Sul"
                    value="MS"
                  ></el-option>
                  <el-option
                    key="MG"
                    label="Minas Gerais"
                    value="MG"
                  ></el-option>
                  <el-option key="PA" label="Pará" value="PA"></el-option>
                  <el-option key="PB" label="Paraíba" value="PB"></el-option>
                  <el-option key="PR" label="Paraná" value="PR"></el-option>
                  <el-option key="PE" label="Pernambuco" value="PE"></el-option>
                  <el-option key="PI" label="Piauí" value="PI"></el-option>
                  <el-option
                    key="RJ"
                    label="Rio de Janeiro"
                    value="RJ"
                  ></el-option>
                  <el-option
                    key="RN"
                    label="Rio Grande do Norte"
                    value="RN"
                  ></el-option>
                  <el-option
                    key="RS"
                    label="Rio Grande do Sul"
                    value="RS"
                  ></el-option>
                  <el-option key="RO" label="Rondônia" value="RO"></el-option>
                  <el-option key="RR" label="Roraima" value="RR"></el-option>
                  <el-option
                    key="SC"
                    label="Santa Catarina"
                    value="SC"
                  ></el-option>
                  <el-option key="SP" label="São Paulo" value="SP"></el-option>
                  <el-option key="SE" label="Sergipe" value="SE"></el-option>
                  <el-option key="TO" label="Tocantins" value="TO"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Objeto">
                <el-input v-model="filter.tag" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Destinatário">
                <el-input v-model="filter.name" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="close">Cancelar</el-button>
          <el-button
            type="info"
            @click="
              $refs.drawer.closeDrawer();
              clear();
            "
            >Limpar filtros</el-button
          >
          <el-button
            type="primary"
            @click="
              $refs.drawer.closeDrawer();
              execute();
            "
            >Filtrar</el-button
          >
        </div>
      </div>
    </el-drawer>
    </el-badge>
</template>

<script>
export default {
  props: ["userType"],
  data() {
    return {
      dialog: false,
      filter: {
        tag: "",
        plp: "",
        zipcode: "",
        state: "",
        name: "",
        records: 50,
        page: 1,
      },
    }
  },
  computed: {
    hasfilter() {
      const vm = this;
      return !(
        vm.filter.tag ||
        vm.filter.plp ||
        vm.filter.zipcode ||
        vm.filter.state ||
        vm.filter.name
      );
    },
  },
  methods: {
    get() {
      return this.filter;
    },
    open() {
      const vm = this;
      vm.dialog = true;
    },
    close() {
      const vm = this;
      vm.dialog = false;
    },
    execute() {
      const vm = this;
      vm.$emit("filter");
      vm.dialog = false;
    },
    clear() {
      const vm = this;
      vm.filter.tag = "";
      vm.filter.plp = "";
      vm.filter.zipcode = "";
      vm.filter.state = "";
      vm.filter.name = "";
    },
  }
}
</script>